module.exports = __webpack_public_path__ + "img/rains_of_terror.265fdc48.jpg";